import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const hasTokenGuard: CanActivateFn = (route, state) => {

  const token = route.queryParamMap.get('token');
  const routerService = inject(Router);
  
  if (!token) {
    routerService.navigate(['/courses']);
    return false
  }

  return true;
};
